import React, { useState, useEffect } from 'react';
import './Sample.css';
import SampleManager from '../SampleManager/SampleManager';
import Validate from '../SampleManager/Validate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

function Sample({ user }) {
    const [activeTab, setActiveTab] = useState('calendar');
    const [samples, setSamples] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);



    return (
        <div className="HomeSample">
            <div className="HomeSample-header">
                <div className="HomeSample-tabs">
                    <button 
                        className={`HomeSample-tab ${activeTab === 'calendar' ? 'active' : ''}`}
                        onClick={() => setActiveTab('calendar')}
                    >
                        <span>Calendar</span>
                    </button>
                    <button 
                        className={`HomeSample-tab ${activeTab === 'validate' ? 'active' : ''}`}
                        onClick={() => setActiveTab('validate')}
                    >
                        <span>Data</span>
                    </button>
                </div>
            </div>
            <div className="HomeSample-content">
                {activeTab === 'calendar' && <SampleManager user={user} />}
                {activeTab === 'validate' && <Validate user={user} samples={samples} />}
            </div>
        </div>
    );
}

export default Sample;
